export interface ReadFile extends File {
    contents?: string | ArrayBuffer;
    status?: UploadStatus;
    progress?: number;
    errors?: string[];
    id?: string;
}

export enum UploadStatus {
    NEW,
    UPLOADING,
    PROCESSING,
    DONE,
    FAILED,
    COMPLETE
}
